// Global store for optimistic ID to real ID mappings
// This allows us to keep optimistic IDs in the UI while using real IDs for API calls
export const optimisticToRealIdMap = new Map<number, number>();

export const getOptimisticToRealIdMap = () => optimisticToRealIdMap;
